module.exports = __webpack_public_path__ + "static/4-08251d9a4887b8e2b40ba1d0c756bca8.jpg";